import { render, staticRenderFns } from "./PropertyGiftModal.vue?vue&type=template&id=6a2fbe85"
import script from "./PropertyGiftModal.vue?vue&type=script&lang=js"
export * from "./PropertyGiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports